import { createSlice } from '@reduxjs/toolkit';

interface PreliminaryProgram {
  intendedUse: string;
  nsrf: string;
  grossBuildingArea: string;
  parkingSpaces: string;
  parkingLocation: string;
}

const initialState: PreliminaryProgram = {
  intendedUse: '',
  nsrf: '',
  grossBuildingArea: '',
  parkingSpaces: '',
  parkingLocation: '',
};

const preliminaryProgramSlice = createSlice({
  name: 'preliminaryProgram',
  initialState,
  reducers: {
    set(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
});

export const { set } = preliminaryProgramSlice.actions;
export default preliminaryProgramSlice.reducer;
